
import React, { useState } from "react";
import styles from "./NavButton.module.css";
import {
  NavButtonProps
} from "./NavButton.types"

const NavButton: React.FC<NavButtonProps> = ({ disabled, onClick, icon }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`
        ${styles.navButton} 
        ${disabled ? styles.navButtonDisabled : ""} 
        ${isHovered && !disabled ? styles.navButtonHover : ""}
      `}
      onClick={disabled ? undefined : onClick}
      onMouseEnter={() => !disabled && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {icon}
    </div>
  );
};

export default NavButton;